/* @flow */

import { type ContextRouter } from 'react-router-dom';
import * as React from 'react';

import RankingPage from '../../common/RankingPage';

const PizzaAdvancedRankingPage = (props: ContextRouter) => (
  <RankingPage
    kind="pizza-a"
    onNextClick={() => {
      props.history.push('/pizza-a/fields?skip_intro=1');
    }}
  />
);

export default PizzaAdvancedRankingPage;
